import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PPUCustomerDetailModel } from '@app/shared/models/customer.model';
import { CustomerService } from '@app/shared/services/customer.service';
import { PPUAlertService } from '@app/shared/services/ppu-alert.service';

@Component({
    selector: 'app-customer-details',
    templateUrl: './customer-details.component.html',
    standalone: false
})
export class CustomerDetailsComponent{
  customer!: PPUCustomerDetailModel
  isLoading: boolean = false;
  
  constructor(
    private dialogRef: MatDialogRef<CustomerDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: number,
    private customerService: CustomerService,
    private ppuAlertService: PPUAlertService
  ) {
    this.dialogRef.updateSize('400px', 'auto')
  }

  ngOnInit(){
    this.isLoading = true;
    this.customerService.getCustomerById(this.data).subscribe({
      next: (result: PPUCustomerDetailModel) => {
        this.customer = result;
        this.isLoading = false;
      },
      error: (error) => {
        this.ppuAlertService.errorEvent(error[0]);
        this.isLoading = false;
      },
    });
  }

  onClose(){
    this.dialogRef.close();
  }
}